import { render, staticRenderFns } from "./TLessonSeo.vue?vue&type=template&id=7cb90452&"
import script from "./TLessonSeo.vue?vue&type=script&lang=js&"
export * from "./TLessonSeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports